import { FileUp, FolderArchive } from 'lucide-react';

import { useAddDeposit } from 'src/context/deposit';
import { storageRegionDictionary } from 'src/shared/entities/storage-regions';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

type IManualUploadItemProps = {
  type: 'secure' | 'repo';
  title: string;
  description: string;
  icon: React.ElementType;
};

const ManualUploadItem = ({ type, title, description, icon: Icon }: IManualUploadItemProps) => {
  const {
    ui: { selectMethod },
  } = useAddDeposit();

  const onClick = () => selectMethod(type);

  return (
    <Card
      onClick={onClick}
      className="cursor-pointer hover:bg-accent transition-colors duration-200"
      role="button"
      tabIndex={0}
    >
      <CardHeader className="items-center pb-4">
        <Icon className="size-9 text-secondary-foreground" />
      </CardHeader>
      <CardContent className="text-center space-y-1.5">
        <CardTitle className="font-semibold tracking-tight">{title}</CardTitle>
        <CardDescription className="text-xs text-foreground">{description}</CardDescription>
      </CardContent>
    </Card>
  );
};

const ManualUploadsContainer = () => {
  const { storageRegion } = useAddDeposit();

  if (!storageRegion || !storageRegionDictionary[storageRegion]) return null;

  return (
    <div className="space-y-4">
      <h2 className="text-base font-bold">Manual uploads</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <ManualUploadItem
          type="secure"
          title="File upload"
          description="Manually upload your assets and information directly to escrow as compressed files."
          icon={FileUp}
        />
        <ManualUploadItem
          type="repo"
          title="Git repository upload"
          description="Manually upload Git repositories as a ZIP file. Add a new repo or upload new versions of existing ones."
          icon={FolderArchive}
        />
      </div>
    </div>
  );
};

export default ManualUploadsContainer;
